<template>
  <div class="star-rating ml-2" @change="avaliarTopico()">
    <input type="radio" id="5-stars" name="rating" value="5" v-model="avaliacao"/>
    <label for="5-stars" class="star"><i class="fas fa-star"></i></label>
    <input type="radio" id="4-stars" name="rating" value="4" v-model="avaliacao"/>
    <label for="4-stars" class="star"><i class="fas fa-star"></i></label>
    <input type="radio" id="3-stars" name="rating" value="3" v-model="avaliacao"/>
    <label for="3-stars" class="star"><i class="fas fa-star"></i></label>
    <input type="radio" id="2-stars" name="rating" value="2" v-model="avaliacao"/>
    <label for="2-stars" class="star"><i class="fas fa-star"></i></label>
    <input type="radio" id="1-star" name="rating" value="1" v-model="avaliacao"/>
    <label for="1-star" class="star"><i class="fas fa-star"></i></label>
  </div>
</template>

<script>
import AvaliacaoTopicoAPI from '../../api/avaliacao-topico-api'

export default {
  name: 'EstrelasAvaliacao',
  props: {
    ementaId: Number,
    targetModal: String,
    rating: Number
  },
  data () {
    return {
      avaliacao: this.rating
    }
  },
  methods: {
    openModal: function () {
      if (this.targetModal) {
        this.$bvModal.show(this.targetModal)
      }
    },

    avaliarTopico: function () {
      let url = window.location.href
      AvaliacaoTopicoAPI.avaliarTopico(this.ementaId, this.avaliacao, url).then(() => {
        this.openModal()
      })
    }
  },
  watch: {
    rating: function (newRating) {
      this.avaliacao = newRating
    }
  }
}
</script>

<style scoped>

</style>
